import { staticImages } from '../../assets/images';
import { getRequestContext } from '../context';

export const STATIC_IMAGES_PUBLIC_PATH = '/static/images';

const imageFiles: Record<string, string> = staticImages;

/**
 * Выбирает URL фиксированного изображения из CDN или Docker-образа.
 * @kind helper
 * @param cdnUrl - исходный URL изображения из manifest
 * @returns URL изображения для выбранного режима
 */
export function getStaticImageUrl(cdnUrl: string): string {
    if (getRequestContext().staticDelivery !== 'local') {
        return cdnUrl;
    }

    const file = imageFiles[cdnUrl];

    if (!file) {
        throw new Error(`Unknown static image: ${cdnUrl}`);
    }

    return `${STATIC_IMAGES_PUBLIC_PATH}/${file}`;
}
